import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mdc-switch",
  type: "button",
  role: "switch"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"mdc-switch__track\"></div><div class=\"mdc-switch__handle-track\"><div class=\"mdc-switch__handle\"><div class=\"mdc-switch__shadow\"><div class=\"mdc-elevation-overlay\"></div></div><div class=\"mdc-switch__ripple\"></div><div class=\"mdc-switch__icons\"><svg class=\"mdc-switch__icon mdc-switch__icon--on\" viewBox=\"0 0 24 24\"><path d=\"M19.69,5.23L8.96,15.96l-4.23-4.23L2.96,13.5l6,6L21.46,7L19.69,5.23z\"></path></svg><svg class=\"mdc-switch__icon mdc-switch__icon--off\" viewBox=\"0 0 24 24\"><path d=\"M20 13H4v-2h16v2z\"></path></svg></div></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _hoisted_4))
}